import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { MarketplaceSellerProfile } from '../models/marketplace-seller-profile';

export const GetSellerProfileByOpportunityId = createAsyncThunk(
    'profilesData/getSellerProfileByOpportunityId',
    async (opportunityId: number, { getState }: any) => {
        const axios = getState().core.axios;
        try {
            const response = await axios.get(`api/Profiles/by-opportunity/${opportunityId}`);
            return response.data as MarketplaceSellerProfile;
        } catch (error) {
            createNotification(
                'Something went wrong, could not load seller profile data. Please try again.',
                'error'
            );
            throw error;
        }
    }
);
